var path = 'public/app/plugins/panel/singlestat/module.html';
var html = "<div class=singlestat-panel>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;